<template>
  <TheForm />
</template>

<script>
import TheForm from './components/TheForm.vue'

export default {
  name: 'App',
  components: {
    TheForm
  }
}
</script>

<style>
h1 {
  font-weight: 700;
  font-size: 2em;
  color: #1267a2;
}

h2 {
  font-weight: 300;
  font-size: 1.5em;
  color: #1267a2;
}

h3 {
  font-weight: 300;
  font-size: 1.3em;
  color: #1267a2;
  margin-top: 30px;

}

form {
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
}

fieldset {
  border-radius: 4px;
  border-color: #efefef;
  margin-bottom: 25px;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 5px;
}

@media screen and (min-width: 601px) {
  .form-items {
    width: 49%;
  }
}

@media screen and (max-width: 600px) {
  .form-items {
    width: 100%;
  }
}

.form-items-large {
  width: 100%;
  margin-bottom: 10px;
}

.layout-column {
  flex-direction: column;
  padding: 0 20px;
}

input[type="text"],
input[type="email"],
input[type="date"] {
  width: 100%;
  height: 42px;
  margin: 6px 0 18px;
  padding: 0 12px;

  font-size: 17px;
  line-height: normal;
  _outline: transparent;
  border: solid 1px #1267a2;
  border-radius: 2px;
  color: #616161;
  box-sizing: border-box;
  transition: padding 0.2s;
}

input[type="file"] {
  font-weight: 600;
  color: #1267a2;
  margin: 6px 0 18px;
  padding: 0 12px;
  cursor: pointer;
}

input[type="radio"] {
  font-weight: 600;
  color: #1267a2;
  margin: 6px 10px 18px;
  padding: 10px 12px;
}

textarea {
  width: calc(100% - 25px);
  margin: 6px 0 18px;
  padding: 12px;
  font-family: "Open Sans", Arial, sans-serif;
  font-size: 1em;
  line-height: 1.3;
  border: solid 1px #1267a2;
  border-radius: 2px;
  color: #616161;
}
.tip {
  font-size: 0.8em;
  margin: 0px 0px 20px 15px;
  padding: 0;
}
button {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.26px;
  text-align: center;
  text-shadow: inherit;
  box-shadow: inherit;
  color: white;
  background: #1267a2;
  text-transform: uppercase;
  border: 1px solid #b4cbdb;
  padding: 12px 35px;
  border-radius: initial;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  transition: 0.3s;
  margin-top: 25px;
  margin-bottom: 10px;
  cursor: pointer;
}

button:hover {
  background: #679fc7;
}

@media screen and (max-width: 600px) {
  .button-large {
    width: 100%;
  }
}

.info-text {
  margin-top: 10px;
  margin-bottom: 100px;
  text-align: justify;
  font-size: 0.8em;
  color: #999;
}

.print-error {
  color: red;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  max-width: 90%;
  background-color: white;
  padding: 20px;
  overflow: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
#modal {
  font-size: 0.9em;
}
#modal ul {
 
  margin: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;

}

.centered-button {
  text-align: center;
}
.note {
  font-size: 0.8em;
}

.greetings {
  display: flex;
  flex-direction: column;
  
  
}
.greetings-text {
  text-align: left;
  height: 100%;
  padding: 20px;
  margin: 20px;
  margin-top: 40px;
}
.text-italic {
  font-style: italic;
}
.loader {
    width: 48px;
    height: 48px;
    border: 5px solid #FFF;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
.sending {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.blue-link {
  
  color: #0666a4;
  text-decoration: none;
  cursor: pointer;
}
.blue-link:hover {
  font-weight: 600;
}

#languages {
  list-style-type: none;
  margin: 0;
  margin-right: 20px;
  padding: 10px;
  font-size: smaller;
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#languages li {
  text-decoration: none;
  padding: 10px;
}
</style>
